import {
  BaseProps,
  CommonStyles,
  Container,
  styled,
  themeColor,
} from '@teko/ds-desktop';
import { ProductCarouselWithHeader } from '@teko/teko-ecommerce';
import { ProductCardProps } from '@teko/types/ecommerce';
import { parseJsonStringSafely } from '@teko/utils';
import { isServerless } from 'helpers';
import { useSearch } from 'hooks';
import { t } from 'i18n';
import React, { ReactElement, useMemo } from 'react';
import { RECENTLY_VIEWED_PRODUCTS_KEY } from '../../../constants';

interface IRecentViewedProductsProps {
  render?: (products: ProductCardProps[]) => ReactElement;
  excludedSkus?: Array<string>;
  isHeadingTitle?: boolean;
}

export const RecentViewedProducts: React.FC<IRecentViewedProductsProps> = (
  props,
) => {
  const { render, excludedSkus, isHeadingTitle = false, ...rest } = props;
  const recentViewedProductsSkus = isServerless()
    ? parseJsonStringSafely<string[]>(
        localStorage.getItem(RECENTLY_VIEWED_PRODUCTS_KEY) || '[]',
        [],
      ) || []
    : [];

  const { result, isLoading } = useSearch(
    recentViewedProductsSkus.length
      ? {
          filter: {
            skus: recentViewedProductsSkus,
            excludedSkus: excludedSkus,
          },
          pageSize: 50,
          page: 1,
        }
      : {},
  );

  const products = useMemo(() => {
    const newProducts: ProductCardProps[] = [];
    recentViewedProductsSkus.forEach((sku: string) => {
      const productFoundBySku = result.products.find(
        (item: ProductCardProps) => item.sku === sku,
      );
      if (productFoundBySku) {
        newProducts.push(productFoundBySku);
      }
    });
    return newProducts;
  }, [result.products]);

  if (!products.length && !isLoading) return null;

  return !!render ? (
    render(products)
  ) : (
    <Container {...rest}>
      <Wrapper>
        <ProductCarouselWithHeader
          header={{ title: t('Sản phẩm vừa xem'), isHeadingTitle }}
          products={products}
          regionName="viewedItem"
        />
      </Wrapper>
    </Container>
  );
};

const Wrapper = styled.div<BaseProps>(
  CommonStyles,
  `
    background: white;
    border-radius: 0.5rem;
    margin-bottom: 1.5rem;
    .product-card{
      border: 1px solid ${themeColor.divider};
      border-radius: 4px;
    }
  `,
);
